export default "__VITE_ASSET__CKcwKS_l__"